// Copyright (c) 2016 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import MachineStatusUpdates, {getDefaultState as getMachineStatusUpdatesDefaultState} from './machine-status-updates';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    hasSearchResults: t.Boolean,
    machineStatusUpdates: MachineStatusUpdates,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        machineStatusUpdates: getMachineStatusUpdatesDefaultState(),
        reportsAccordion: getAccordionDefaultState('machine-status-update-reports'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: ''
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/machine-status-update/state/index.js